export enum AccountSetupStepEnum {
  BASIC_INFO = 1,
  BUSINESS_INFO = 2,
  INTEGRATIONS = 3,
  OFFICES = 4,
  PORTALS = 5,
}
